<mat-progress-bar *ngIf="drawViewService.isLoading && applicationService.appStarted"
                  [value]="drawViewService.loadingStatus"
                  mode="determinate"></mat-progress-bar>


<div style="height: 100%; overflow: hidden">

    <div class="site-content">
        <mat-button-toggle-group #headgroup [(value)]="drawViewService.interactionMode">
            <mat-button-toggle #transformBtn
                               (click)="singleTap($event, 'transform')"
                               [checked]="true" value="transform">
                <mat-icon>pan_tool</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle #paintBtn
                               (click)="singleTap($event, 'paint')"
                               (dblclick)="doubleTap($event, 'paint')"
                               [disabled]="!drawViewService.paintingLoaded" value="paintMode">
                <s3design-icon name="brush"></s3design-icon>
            </mat-button-toggle>

            <mat-button-toggle #eraseBtn
                               (click)="singleTap($event, 'erase')"
                               (dblclick)="doubleTap($event, 'erase')"
                               [disabled]="!drawViewService.paintingLoaded" value="eraseMode">
                <s3design-icon name="eraser"></s3design-icon>
            </mat-button-toggle>

            <mat-button-toggle #measureBtn (click)="singleTap($event, 'measure')" value="measureMode"
                               *ngIf="!clientInfoService.isTouchDevice">
                <mat-icon>square_foot</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle #infoBtn (click)="singleTap($event, 'info')"
                               *ngIf="!clientInfoService.isTouchDevice"
                               value="infoMode">
                <mat-icon>info</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>


        <mat-button-toggle-group (change)="toggleChanged($event)" *ngIf="!clientInfoService.isTouchDevice" multiple>
            <mat-button-toggle (click)="save()" *ngIf="drawViewService.databaseConnected" name="reset"
                               style="min-width: unset;">
                <mat-icon>save</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle (click)="drawViewService.resetCamera()" name="reset" style="min-width: unset;">
                <s3design-icon name="reset"></s3design-icon>
            </mat-button-toggle>
            <mat-button-toggle (click)="drawViewService.openConfirmationDialog()" name="clear"
                               style="min-width: unset;">
                <s3design-icon name="clear"></s3design-icon>
            </mat-button-toggle>
            <mat-button-toggle (click)="photoUpload.click()" style="min-width: unset;">
                <mat-icon>add_a_photo</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle (click)="drawViewService.openImageDialog()" *ngIf="drawViewService.pictureDrawn"
                               style="min-width: unset;">
                <mat-icon>compare</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle (click)="drawViewService.exportGltf()"
                               style="min-width: unset;">
                <mat-icon>import_export</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>

        <mat-button-toggle-group (change)="toggleChanged($event)" *ngIf="clientInfoService.isTouchDevice" multiple>
            <mat-button-toggle (click)="drawViewService.resetCamera()" name="reset" style="min-width: unset;">
                <s3design-icon name="reset"></s3design-icon>
            </mat-button-toggle>
            <mat-button-toggle #menubtn (change)="menubtn.checked = false" [checked]="false" [matMenuTriggerFor]="menu"
                               value="left">
                <mat-icon>menu</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>

        <mat-menu #menu="matMenu">
            <button (click)="drawViewService.openConfirmationDialog()" mat-menu-item name="clear"
                    style="min-width: unset;">
                <mat-icon>
                    <s3design-icon name="clear"></s3design-icon>
                </mat-icon>
                {{'Clear Model' | translate}}
            </button>
            <button (click)="photoUpload.click()" mat-menu-item>
                <mat-icon>add_a_photo</mat-icon>
                {{'Upload Image' | translate}}
            </button>
            <button (click)="drawViewService.openImageDialog()" *ngIf="drawViewService.pictureDrawn"
                    mat-menu-item>
                <mat-icon>compare</mat-icon>
                {{'Edit Image' | translate}}
            </button>

            <button #measureBtn (click)="singleTap($event, 'measure')" mat-menu-item value="measureMode">
                <mat-icon>square_foot</mat-icon>
                {{'Measure distances' | translate}}
            </button>
            <button (click)="singleTap($event, 'info')" mat-menu-item value="info">
                <mat-icon>info</mat-icon>
                {{'Info' | translate}}
            </button>
        </mat-menu>


        <mat-form-field class="select-degree">
            <mat-label>{{'Burn Degree' | translate}}:</mat-label>
            <mat-select (selectionChange)="drawViewService.changePaintColor()"
                        [(value)]="drawViewService.selectedDegree" label="Burn Degree">
                <mat-option value="2a"><span class="option-text">2a</span><span class="dot color-2a"></span>
                </mat-option>
                <mat-option value="2b"><span class="option-text">2b</span><span class="dot color-2b"></span>
                </mat-option>
                <mat-option value="3"><span class="option-text">3 &nbsp;</span><span class="dot color-3"></span>
                </mat-option>
                <mat-option value="4"><span class="option-text">4 &nbsp;</span><span class="dot color-4"></span>
                </mat-option>
            </mat-select>
            <span [style.backgroundColor]="drawViewService.selectedColor" class="dot selected-color"></span>

        </mat-form-field>
    </div>
</div>

<input #photoUpload (change)="onPhotoSelected($event, photoUpload)" style="display: none"
       type="file">
